// // src/pages/HomePage.js
import React from 'react';
import { Box, Typography, Grid, Card, CardActionArea, CardContent } from '@mui/material';
import HearingIcon from '@mui/icons-material/Hearing';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {
  const navigate = useNavigate();
  const cardSize = { height: 150, width: '120px' };

  const evaluationCards = [
    { label: 'Pitch & Loudness',  icon: <HearingIcon sx={{ fontSize: 38, color: '#1a237e' }} /> , to: '/loudness', bg: '#ADD8E6' },
    { label: 'MCL', icon: <VolumeUpIcon sx={{ fontSize: 38, color: '#1b5e20' }} />, to: '/mcl', bg: '#72d389' }
  ];

  const treatmentCards = [
    { label: 'FDT', icon:<GraphicEqIcon sx={{ fontSize: 38, color: '#bf360c' }} />, to: '/fdt', bg: '#f0a759' }
  ];

  const renderCards = (cards) => (
    <Grid container spacing={2} justifyContent="center">
      {cards.map(item => (
        <Grid item xs={12} sm={6} md={4} key={item.label}>
          <Card sx={{ ...cardSize }}>
            <CardActionArea onClick={() => navigate(item.to)} sx={{ height: '100%' }}>
              <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', bgcolor: item.bg }}>
                {item.icon}
                <Typography sx={{ mt: 1 }}>{item.label}</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 1 }} textAlign={'center'}>Evaluation</Typography>
      {renderCards(evaluationCards)}

      <Box mt={4}>
        <Typography variant="h6" sx={{ mb: 1 }} textAlign={'center'}>Treatment</Typography>
        {renderCards(treatmentCards)}
      </Box>
    </Box>
  );
}

// src/pages/HomePage.js// src/pages/HomePage.js

